import React, { ReactNode } from "react"
import { useRouter } from "next/router"
import Breadcrumb, { BreadcrumbItem } from "../../components/breadcrumbs"

import { BlokImage } from "../types"
import LocalPetsHero from "./LocalPetsHero"

export interface Props {
  shipmentProof?: ReactNode
  subheading?: string
  heading: string
  buttonLink: string
  buttonLabel: string
  smBgImage: { alt: string; filename: string }
  description: string
  image?: { alt: string; filename: string }
  hasLongDescription: boolean
  items: BreadcrumbItem[]
  collage?: Array<{
    alt: string
    filename: string | undefined
    desktopFilename?: string | undefined
  }>
  forceCollageOnMobile?: boolean
}

const LocalPageHeader = ({
  items,
  shipmentProof,
  subheading,
  heading,
  buttonLink,
  buttonLabel,
  smBgImage,
  description,
  image,
}: Props) => {
  const { query } = useRouter()
  const param = (query?.kw as string) || ""

  return (
    <>
      <LocalPetsHero
        blok={{
          tagline: "#1 Pet Transport Platform in the US",
          title: heading,
          description,
          buttonLabel,
          buttonLink,
          image: {
            alt: image?.alt,
            filename: image?.filename,
          } as BlokImage,
          isNavHidden: true,

          smImage: {
            alt: smBgImage?.alt,
            filename: smBgImage?.filename,
          } as BlokImage,
          isAnimals: true,
        }}
        shipmentProof={shipmentProof}
        items={items}
        subHeading={subheading}
      />
    </>
  )
}

export default LocalPageHeader
